// extracted by mini-css-extract-plugin
export var label = "_fr-0";
export var treatmentCard = "_fr-1";